/**
 * useUserLocation
 */

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

const {
    useQuery,
} = ApolloLib;

const {
    GET_USER_LOCATION,
} = Queries;

const useUserLocation = ({ token, runTimeConfig }, options = {}) => {

    const {
        ssr = false,
        skip = false,
    } = options;

    const {
        loading,
        data,
        error,
    } = useQuery(
        GET_USER_LOCATION,
        {
            variables: {
                token,
                runTimeConfig,
            },
            ssr,
            skip,
        }
    );

    return {
        loading,
        error,
        data: data?.userLocation || {},
    };

};

export default useUserLocation;
